// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".folder_list-module__button--2zTTE{margin-right:10px;max-width:100%;margin-bottom:12px}\n", ""]);
// Exports
exports.locals = {
	"button": "folder_list-module__button--2zTTE"
};
module.exports = exports;
